import React, { memo, useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { CheckoutForm } from "./checkout-form";
import { pendingBookingStore } from "../../../stores/pending-booking.store";
import { useTranslation } from "react-i18next";
import { StripeElementLocale, StripeElementsOptions } from "@stripe/stripe-js";

const Payment = ({ clazz }) => {
  const [stripe] = useState(pendingBookingStore.stripePromise);
  const { i18n } = useTranslation();
  useEffect(() => {
    //navigationStore.currentRoute = buildRouteWithParams(config.routes.confirmation);
  }, []);
  const stripeOption: StripeElementsOptions = {
    locale: i18n.language as StripeElementLocale,
  };
  /*/!\ changing locale while already rendering, leads to re-render component, hence lost card info"*/
  return (
    <>
      {stripe && (
        <Elements key={i18n.language} options={stripeOption} stripe={stripe}>
          <CheckoutForm clazz={clazz} />
        </Elements>
      )}
    </>
  );
};

export const ConfirmationPayment = memo(Payment);
